import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import TabPanel from 'devextreme-react/tab-panel';
import 'devextreme-react/text-area';

import { AppLayoutTop } from 'components/appComponents';
import { useAuth } from 'context/auth';
import { ContractorDeliveryPriceScreen } from 'pages/Contractor/ContractorDeliveryPrice';
import { ContractorDriverPumpPrice } from 'pages/Contractor/ContractorDriverPumpPrice';
import { ContractorPumpPriceScreen } from 'pages/Contractor/ContractorPumpPrice/ContractorPumpPriceScreen';

import { useGetContractorDetailInfoQuery } from 'bus/contractor/services/services';

import { BankDetails, MainInfo, Objects, Pricing, Transport } from '../../components';

const itemTitleRender = (tab: { name: string; index: number }) => <span>{tab.name}</span>;

const Employee: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();

  const { data } = useGetContractorDetailInfoQuery({ id });

  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [typeContractor, setTypeContractor] = useState<number | null>(null);

  const shortName = data?.name;

  const canLookPrice = getClaims(['CanLookContractorNomenclaturePrice']);
  const canLookDeliveryPrice = getClaims(['CanLookDeliveryPrice']);
  const canLookPumpPrice = getClaims(['CanLookPumpPrice']);
  const canLookContractorPumpPrice = getClaims(['CanLookPumpPrice']);

  useEffect(() => {
    if (data) {
      setTypeContractor(data.contractorType);
    }
  }, [data]);

  const tabs = useCallback(
    (typeContractor: number | null) => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: ' Реквизиты',
        index: 1,
        visible: typeContractor === 0 || typeContractor === 1,
      },
      {
        name: 'Транспорт',
        index: 2,
      },
      {
        name: 'Объекты',
        index: 3,
      },
      {
        name: 'Цена за куб',
        index: 4,
        visible: canLookPrice,
      },
      {
        name: 'Цена за доставку',
        index: 5,
        visible: canLookDeliveryPrice,
      },
      {
        name: 'Цена за насос',
        index: 6,
        visible: canLookPumpPrice,
      },
      {
        name: 'Ставка водителям насоса',
        index: 7,
        visible: canLookContractorPumpPrice,
      },
    ],
    [canLookContractorPumpPrice, canLookDeliveryPrice, canLookPrice, canLookPumpPrice],
  );

  const tabsList = useMemo(() => tabs(typeContractor), [tabs, typeContractor]);

  return (
    <div>
      <AppLayoutTop title={'Контрагент - ' + shortName} />
      <TabPanel
        height="auto"
        dataSource={tabsList}
        selectedIndex={selectedIndex}
        onOptionChanged={({ name, value }) => {
          if (name === 'selectedIndex') setSelectedIndex(value);
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
      />
      {selectedIndex === 0 && (
        <div className="tab-content">
          <MainInfo typeContractor={typeContractor} />
        </div>
      )}
      {selectedIndex === 1 && (
        <div className="tab-content">
          <BankDetails />
        </div>
      )}
      {selectedIndex === 2 && (
        <div className="tab-content">
          <Transport />
        </div>
      )}
      {selectedIndex === 3 && (
        <div className="tab-content">
          <Objects />
        </div>
      )}
      {selectedIndex === 4 && (
        <div className="tab-content">
          <Pricing />
        </div>
      )}
      {selectedIndex === 5 && (
        <div className="tab-content">
          <ContractorDeliveryPriceScreen />
        </div>
      )}
      {selectedIndex === 6 && (
        <div className="tab-content">
          <ContractorPumpPriceScreen />
        </div>
      )}
      {selectedIndex === 7 && (
        <div className="tab-content">
          <ContractorDriverPumpPrice />
        </div>
      )}
    </div>
  );
};

export default Employee;
